import type { JSX, ReactNode } from 'react'

import { Notice } from '@buffer-mono/popcorn'

import { useOptionalNotesDismissGuard } from '~publish/hooks/notes/NotesDismissGuard'

import styles from './PostNotes.module.css'

export function NotesDismissWarn({
  enabled = true,
  children,
}: {
  enabled?: boolean
  children: ReactNode
}): JSX.Element {
  const guard = useOptionalNotesDismissGuard()
  const warn = enabled && guard?.warn === true
  return (
    <div>
      {warn && (
        <Notice
          variant="warning"
          aria-live="polite"
          className={styles.dismissNotice}
        >
          Your changes will be lost.
        </Notice>
      )}
      <div
        className={warn ? styles.composerShake : undefined}
        onFocusCapture={() => guard?.clearWarn()}
      >
        {children}
      </div>
    </div>
  )
}
